exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ps-dom-highlight[data-v-39a7edc2]{opacity:.75!important;border-color:rgba(159 183 10,.9)!important;-webkit-box-shadow:0 0 0 20px rgba(159 183 10,.25)!important;box-shadow:0 0 0 20px rgba(159 183 10,.25)!important}", ""]);

// exports
